'use strict';

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('tablesorter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.load)('*');

document.addEventListener('index', loadIndex);

if ((0, _jquery2.default)('body').hasClass('template-index')) {
    loadIndex();
}

function loadIndex() {
    (0, _jquery2.default)("#IndexTable").tablesorter();
    (0, _jquery2.default)('tbody tr').off('click').on('click', function () {
        var url = (0, _jquery2.default)(this).data('url');
        console.log(url);
        var event = new CustomEvent('goTo', { 'detail': url });
        document.dispatchEvent(event);
    });
}